import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "@/pages/Home";
import Dashboard from "@/pages/Dashboard";
import CityPage from "@/pages/CityPage";
import GuidesIndex from "@/pages/GuidesIndex";
import GuidePage from "@/pages/GuidePage";
import AdminAnalytics from "@/pages/AdminAnalytics";
import TrackPageViews from "@/components/TrackPageViews";
import { CITIES } from "@/data/cities";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <BrowserRouter>
      <TrackPageViews />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/map" element={<Dashboard />} />
        <Route path="/guides" element={<GuidesIndex />} />
        <Route path="/guides/:slug" element={<GuidePage />} />
        <Route path="/admin/analytics" element={<AdminAnalytics />} />
        {CITIES.map((c) => (
          <Route key={c.slug} path={`/can-i-fly-a-drone-in-${c.slug}`} element={<CityPage slug={c.slug} />} />
        ))}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster position="top-center" theme="dark" />
    </BrowserRouter>
  );
}

export default App;
